import { useQuickstartState } from '@confluence/onboarding-quickstart';
import { useRightSidebarContext } from '@confluence/page-layout-context';

const QUICKSTART_PANEL_COMPENSATION_PX = 368;

export const useRightSidebarCompensation = () => {
	const { isPanelOpen, isDismissed } = useQuickstartState();
	const { sidebars } = useRightSidebarContext();

	const isQuickstartOpen = isPanelOpen && !isDismissed;
	const isInProductHelpOpen =
		sidebars.findIndex((sidebar) => sidebar.panelId === 'in-product-help') >= 0;

	// The quickstart menu is only displayed if it has been set to open and the IPH menu is closed.
	// Other non-IPH sidebars do not hide the quickstart menu.
	const quickstartCompensation = isQuickstartOpen
		? isInProductHelpOpen
			? 0
			: QUICKSTART_PANEL_COMPENSATION_PX
		: 0;

	const rightSidebarCompensation =
		quickstartCompensation +
		sidebars.reduce((accumulator, sidebar) => {
			if (sidebar.isCollapsed || sidebar.isMinimized) {
				return accumulator;
			}
			return accumulator + sidebar.width;
		}, 0);

	return rightSidebarCompensation;
};
